import request from '@/utils/request'
const key = 'auth'
export function login(data) {
  return request({
    url: `/api/${key}/login`,
    method: 'post',
    data
  })
}

export function getInfo(params) {
  return request({
    url: `/api/${key}/user`,
    method: 'get',
    params
  })
}

export function logout() {
  return request({
    url: `/api/${key}/logout`,
    method: 'get'
  })
}

export function resetPassword(data) {
  return request({
    url: `/platform/${key}/resetPassword`,
    method: 'post',
    data
  })
}

//
export function fetchCollectList(params) {
  return request({
    url: `/api/user/collection`,
    method: 'get',
    params
  })
}

// 收藏
export function addCollect(data) {
  return request({
    url: `/api/user/collection`,
    method: 'post',
    data
  })
}

// 取消收藏
export function cancelCollect(data) {
  return request({
    url: `/api/user/collection/${data.id}`,
    method: 'delete',
    data
  })
}

// 
export function getCustomerInfo(params) {
  return request({
    url: `/pub/jinduo/oa/stores`,
    method: 'get',
    params
  })
}

// 
export function editPsw(data) {
  return request({
    url: `/api/auth/password`,
    method: 'put',
    data
  })
}
